import {
  LayoutDashboard, Users, Phone, Target, Calendar,
  Package, FileText, ClipboardList, LifeBuoy, Mail, MessagesSquare,
  type LucideIcon,
} from 'lucide-react';

export type ModulKey =
  | 'dashboard' | 'musteri' | 'aktivite' | 'firsat' | 'teklif'
  | 'siparis' | 'urun' | 'destek' | 'eposta' | 'takvim' | 'meta';

export interface ModulTanim {
  key: ModulKey;
  to: string;
  i18n: string;
  label: string;
  icon: LucideIcon;
  /** Dashboard her zaman görünür — kapatılamaz. */
  zorunlu?: boolean;
}

export const MODULLER: ModulTanim[] = [
  { key: 'dashboard', to: '/dashboard', i18n: 'menu.dashboard', label: 'Panel', icon: LayoutDashboard, zorunlu: true },
  { key: 'musteri', to: '/musteriler', i18n: 'menu.musteriler', label: 'Müşteriler', icon: Users },
  { key: 'aktivite', to: '/aktiviteler', i18n: 'menu.aktiviteler', label: 'Aktiviteler', icon: Phone },
  { key: 'firsat', to: '/firsatlar', i18n: 'menu.firsatlar', label: 'Fırsatlar', icon: Target },
  { key: 'teklif', to: '/teklifler', i18n: 'menu.teklifler', label: 'Teklifler', icon: FileText },
  { key: 'siparis', to: '/siparisler', i18n: 'menu.siparisler', label: 'Siparişler', icon: ClipboardList },
  { key: 'urun', to: '/urunler', i18n: 'menu.urunler', label: 'Ürünler', icon: Package },
  { key: 'destek', to: '/talepler', i18n: 'menu.talepler', label: 'Destek Talepleri', icon: LifeBuoy },
  { key: 'eposta', to: '/epostalar', i18n: 'menu.epostalar', label: 'E-postalar', icon: Mail },
  { key: 'meta', to: '/meta-yonetim', i18n: 'menu.metaYonetim', label: 'Meta Yönetim', icon: MessagesSquare },
  { key: 'takvim', to: '/takvim', i18n: 'menu.takvim', label: 'Takvim', icon: Calendar },
];

export const MODUL_MAP = Object.fromEntries(MODULLER.map((m) => [m.key, m])) as Record<ModulKey, ModulTanim>;
